<app-progress-bar></app-progress-bar>
@if ( this.passwordToken != "") {
  <section class="main-login up-down">
    <!-- Contenedor imagen y formulario recover password -->
    <div class="login-container">
        <!-- Contenedor formulario-->
        <div class="login-container__content">
            <div class="login-container__content__title">
              @if(isRecovery){
                <h5>{{ translatedTextKeyPasswordRecovery.PASSWORD_RECOV_TITTLE | translate }}</h5>
                <p>
                    {{ translatedTextKeyPasswordRecovery.PASSWORD_RECOV_RECOVERY_SUBTITTLE | translate }}
                </p>
              }@else{
                <h5>{{ translatedTextKeyPasswordRecovery.PASSWORD_NEW_TITTLE | translate }}</h5>

              }

            </div>
            <div class="login-container__content__form">
                <form [formGroup]="passwordRecoveryForm" class="login-form">
                    <div class="login-form__inputs">
                        <div class="login-form__inputs__field">
                            <div class="form-field">
                                <label>
                                    {{ translatedTextKeyPasswordRecovery.PASSWORD_RECOV_PASSWORD_INPUT | translate }}*
                                </label>
                                <input
                                    type="password"
                                    id="password"
                                    (keyup)="handleKeyUp($event)"
                                    pInputText formControlName="password"
                                    [placeholder]="translatedTextKeyPasswordRecovery.PASSWORD_RECOV_PASSWORD_INPUT  | translate "
                                    [ngClass]="{ 'input-error': passwordRecoveryForm.get('password').errors && (passwordRecoveryForm.get('password').dirty || passwordRecoveryForm.get('password').touched) }"
                                    >
                                <span class="form-field__show-pass"  (click)="togglePassword('password')">
                                    <img src="./../../../../../assets/images/icons/show-password-icon.svg" alt="">
                                </span>
                            </div>
                            <div class="text-danger"
                                *ngIf="passwordRecoveryForm.get('password').errors && (passwordRecoveryForm.get('password').dirty || passwordRecoveryForm.get('password').touched)">
                                <ul>
                                    <li *ngIf="passwordRecoveryForm.get('password').errors?.['required']">{{
                                        translatedTextKeyPasswordRecovery.PASSWORD_RECOV_PASSWORD_REQUIRED |
                                        translate }}</li>
                                    <li *ngIf="passwordRecoveryForm.get('password').errors?.['passwordPolicy']">{{
                                        translatedTextKeyPasswordRecovery.PASSWORD_RECOV_PASSWORDINVALID | translate
                                        }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="login-form__inputs__field">
                            <div class="form-field">
                                <label>
                                    {{ translatedTextKeyPasswordRecovery.PASSWORD_RECOV_CONFIRM_PASSWORD_INPUT |
                                    translate }}*
                                </label>
                                <input
                                    type="password"
                                    id="confirmpassword"
                                    (keyup)="handleKeyUp($event)"
                                    pInputText formControlName="confirmpassword"
                                    [placeholder]="translatedTextKeyPasswordRecovery.PASSWORD_RECOV_CONFIRM_PASSWORD_INPUT | translate "
                                    [ngClass]="{ 'input-error': passwordRecoveryForm.get('confirmpassword').errors && (passwordRecoveryForm.get('confirmpassword').dirty || passwordRecoveryForm.get('confirmpassword').touched) }"
                                    >
                                <span class="form-field__show-pass"  (click)="togglePassword('confirmpassword')">
                                    <img src="./../../../../../assets/images/icons/show-password-icon.svg" alt="">
                                </span>
                            </div>
                            <div class="text-danger"
                                *ngIf="passwordRecoveryForm.get('confirmpassword').errors && (passwordRecoveryForm.get('confirmpassword').dirty || passwordRecoveryForm.get('confirmpassword').touched)">
                                <ul>
                                    <li *ngIf="passwordRecoveryForm.get('confirmpassword').errors?.['passwordMismatch']">
                                        {{ translatedTextKeyPasswordRecovery.PASSWORD_RECOV_CONFIRM_PASSWORD_EQUALS
                                        | translate }}</li>
                                    <li *ngIf="passwordRecoveryForm.get('confirmpassword').errors?.['required']">{{
                                        translatedTextKeyPasswordRecovery.PASSWORD_RECOV_CONFIRM_PASSWORD_EQUALS |
                                        translate }} </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="login-form__buttons">
                        <button [disabled]="!this.allowSend" class="login-form__buttons__login-button p-button-success" pButton type="button"
                            [label]="translatedTextKeyPasswordRecovery.SEND|translate"
                            (click)="RecoverPassword()"></button>
                    </div>
                </form>
            </div>

        </div>
        <!-- Contenedor imagen-->
        <div class="login-container__image">
            <img
              [src]="backgroundImage"
              alt="Argos ONE 2G Image"
            />
          </div>
    </div>
</section>
}@else{
  <section class="main-login up-down">
    <!-- Contenedor imagen y formulario recover password -->
    <div class="login-container">
        <!-- Contenedor formulario-->        <div class="login-container__content">
            <div class="login-container__content__title">
                <h5>{{ 'mcfLoginShell.passwordRecovery.resetPassword' | translate }}</h5>
                <p>
                    {{ 'mcfLoginShell.passwordRecovery.enterEmailToReset' | translate }}
                </p>
            </div>
            <div class="login-container__content__form">
                <form [formGroup]="passwordRecoveryEmailForm" class="login-form">
                    <div class="login-form__inputs">
                        <div class="login-form__inputs__field">
                            <div class="form-field">
                                <label>
                                   {{ 'mcfLoginShell.passwordRecovery.email' | translate }}
                                </label>
                                <input
                                    type="text"
                                    pInputText
                                    formControlName="email"
                                    class="form-field--user"
                                    [ngClass]="{ 'input-error': passwordRecoveryEmailForm.get('email').errors && (passwordRecoveryEmailForm.get('email').dirty || passwordRecoveryEmailForm.get('email').touched) }"
                                    >
                            </div>                            <div class="text-danger"
                                *ngIf="passwordRecoveryEmailForm.get('email').errors && (passwordRecoveryEmailForm.get('email').dirty || passwordRecoveryEmailForm.get('email').touched)">
                                <ul>
                                    <li *ngIf="passwordRecoveryEmailForm.get('email').errors?.['required']">{{ 'mcfLoginShell.passwordRecovery.required' | translate }}</li>
                                    <li *ngIf="passwordRecoveryEmailForm.get('email').errors?.['email']">{{ 'mcfLoginShell.passwordRecovery.invalidEmail' | translate }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="login-form__buttons login-form__buttons--multiple">                        <button
                            class="login-form__buttons__login-button p-button-success login-form__buttons__login-button--back"
                            pButton type="button"
                            (click)="goToComponent('PasswordRecoveryPathEnum.ReturnAutPath')">
                            <i class="icon-arrow-back"></i>
                            {{ 'mcfLoginShell.passwordRecovery.goBack' | translate }}
                        </button>
                        <button class="login-form__buttons__login-button p-button-success" pButton type="button" (click)="SendRecoveryEmail()">
                            <i class="icon-approved"></i>
                            {{ 'mcfLoginShell.send' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <!-- Contenedor imagen-->
        <div class="login-container__image">
            <img
              [src]="backgroundImage"
              alt="Argos ONE 2G Image"
            />
          </div>
    </div>
  </section>


}
<app-app-modal></app-app-modal>
